/**
 * The people you can be, by id. Shared by the lobby (which validates and relays the
 * choice, and checks ownership of the paid ones) and the hall (which knows how each looks).
 *
 * Sam, Nora, Nino and Gab are free. Retired characters are no longer offered or
 * assigned, but their past purchases remain recognizable.
 */
export const FREE_AVATARS = ['sam', 'nora', 'nino', 'gab'];
export const PAID_AVATARS = [];
export const AVATAR_IDS = [...FREE_AVATARS, ...PAID_AVATARS];

export function isAvatarId(id) {
  return typeof id === 'string' && AVATAR_IDS.includes(id);
}

export function isPaidAvatar(id) {
  return typeof id === 'string' && PAID_AVATARS.includes(id);
}

/** Historical checkout receipts remain valid even after an avatar is retired. */
export function isPurchasedAvatarId(id) {
  return isPaidAvatar(id) || id === 'ninja' || id === 'robot' || id === 'diva';
}

export function randomFreeAvatarId() {
  return FREE_AVATARS[Math.floor(Math.random() * FREE_AVATARS.length)];
}
